<section class="policiesDetail__policies-banner" *ngIf="showCancellationBanner">
  <app-free-cancellation></app-free-cancellation>
</section>
<div class="policiesDetail__policies-accordion">
  <app-ds-accordion
    [type]="accordionType"
    [size]="accordionSize"
    [initState]="!isUserHistory"
    [text]="
      isOneWay ?
      ('BOOKING_MODULE.CHANGE_CANCEL_POLICIES.FLIGHT_POLICIES.ONEWAY' | transloco : { departure: flightDeparture, arrival: flightArrival }) :
      ('BOOKING_MODULE.CHANGE_CANCEL_POLICIES.FLIGHT_POLICIES.ROUNDTRIP' | transloco : { departure: flightDeparture, arrival: flightArrival })
    ">
    <div class="policiesDetail__policies-accordion-item">
      @if (hasFareConditions) {
        <ng-container *ngFor="let flight of airValidation?.AirFareConditions as conditions; let i = index">
          <div class="policiesDetail__policies-accordion-item-title">
            <app-ds-typography
              [size]="fontSize.XS"
              [color]="fontColor.Primary"
              [fontFamily]="fontFamily.SemiBold"
              [text]="('FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.FLIGHT' | transloco : { flight: flightKeys(flight, i) })">
            </app-ds-typography>
          </div>
          <app-changes-policies [flight]="flight"></app-changes-policies>
          <app-cancellation-policies *ngIf="showFreeCancellation" [flight]="flight"></app-cancellation-policies>
          <app-no-show-policies [flight]="flight" [isLast]="isLastFareCondition(i,conditions)"></app-no-show-policies>
        </ng-container>
        <div class="policiesDetail__policies-accordion-item-divider">
          <app-ds-divider></app-ds-divider>
        </div>
        <div class="policiesDetail__policies-accordion-item-footer">
          <div class="policies-footer">
            <app-ds-typography
              [size]="fontSize.XXXS"
              [color]="fontColor.Secondary"
              [fontFamily]="fontFamily.Regular"
              [text]="('BOOKING_MODULE.CHANGE_CANCEL_POLICIES.POLICY_FOOT_NOTE' | transloco) + ' ' + ('BOOKING_MODULE.CHANGE_CANCEL_POLICIES.POLICY_FOOT_NOTE_ADDITIONAL_INFO' | transloco)">
            </app-ds-typography>
          </div>
        </div>
      } @else {
        <app-ds-typography
          [size]="fontSize.XXXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.AIRLINE_EMPTY_POLICIES' | transloco : { airlineName: airlineName }">
        </app-ds-typography>
      }
    </div>
  </app-ds-accordion>
</div>

